import { SCREEN_BREAKPOINT } from '@components/Grid/Grid.style';
import { StyledLabel } from '@components/Text';
import styled from '@emotion/styled';

export const RefBtnLabel = styled(StyledLabel)<{ index: number; selectedIndex: number }>`
  ${({ index, selectedIndex }) => (index === selectedIndex ? `color : #2A70F0;` : 'color : #818181;')}
`;

export const RefAButton = styled.div`
  max-width: 100%;
  display: flex;
  flex-direction: row;
  justfiy-content: center;
  align-items: center;
  height: 100%;
  padding: 16px;
`;
